'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _documentHeader = require('./document-header');

var _documentHeader2 = _interopRequireDefault(_documentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Space = _react2['default'].createElement(
    'u',
    null,
    '\xA0'.repeat(10)
);
var DocumentBody = _react2['default'].createElement(
    'div',
    { className: 'm-document-body' },
    _react2['default'].createElement(
        'h1',
        null,
        'NON-DISCLOSURE AGREEMENT'
    ),
    _react2['default'].createElement(
        'p',
        null,
        'THIS AGREEMENT (the "Agreement") is entered into on this',
        Space,
        ' day of ',
        Space,
        ' by and between ',
        Space,
        ', located at',
        Space,
        ' (the "Disclosing Party"), and ',
        Space,
        ' with and address at ',
        Space,
        ' (the "Recipient" or the "Receiving Party").'
    ),
    _react2['default'].createElement(
        'p',
        null,
        'The Recipient hereto desires to participate in discussions regarding ',
        Space,
        ' (the "Transaction").During these discussions, Disclosing Party may share certain proprietary information with the Recipient.Therefore, in consideration of the mutual promises and covenants contained in this Agreement, and other good and valuable consideration, the receipt and sufficiency of which is hereby acknowledged, the parties hereto agree as follows:'
    )
);

var DocumentUI = function (_React$Component) {
    _inherits(DocumentUI, _React$Component);

    function DocumentUI() {
        _classCallCheck(this, DocumentUI);

        return _possibleConstructorReturn(this, (DocumentUI.__proto__ || Object.getPrototypeOf(DocumentUI)).apply(this, arguments));
    }

    _createClass(DocumentUI, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'section',
                { className: 'm-document-container' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    _react2['default'].createElement('img', { src: require('./assets/1.png') }),
                    _react2['default'].createElement(
                        'span',
                        null,
                        'First, select an area or text below.'
                    ),
                    _react2['default'].createElement('img', { src: require('./assets/arrow_1.png'), className: 'arrow-1' })
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-document' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-document-inner' },
                        _react2['default'].createElement(_documentHeader2['default'], this.props),
                        DocumentBody
                    )
                )
            );
        }
    }]);

    return DocumentUI;
}(_react2['default'].Component);

module.exports = DocumentUI;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/document-ui.jsx
 ** module id = 1277
 ** module chunks = 0
 **/